import request from "@/apis/request"

export function loginByWechat(data) {
    return request({
        url: '/loginByWechat',
        method: "POST",
        data
    })
}

// 根据token取用户信息
export function getUserInfoByToken() {
    return request({
        url: '/loginUserByToken',
        method: "post",
    })
}

export function getWechatSDKSignature(data) {
    return request({
        url: '/getWechatSDKSignature',
        method: "POST",
        data
    })
}